import { Box, useTheme, Typography } from '@mui/material';
import CardImage2 from '@/components/reading/CardImage2';
import { TarotCard } from '@/context/CardsContext';
import { useTranslation } from 'react-i18next';
interface DailyReadingCardDisplayProps {
    card: TarotCard;
    isCardFlipped: boolean;
}

const DailyReadingCardDisplay: React.FC<DailyReadingCardDisplayProps> = ({
    card,
    isCardFlipped
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    console.log('Card:', card);
    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            gap: 1,
            padding: '0px',
            alignItems: 'flex-start'
        }}>
            {/* Left side - Card */}
            <Box sx={{
                flex: '0 0 auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <CardImage2
                    id={card?.id || 0}
                    visible={!!card}
                    showFront={isCardFlipped}
                    reversed={card?.reversed || false}
                    width={130}
                    description={card?.description}
                    onCardClick={() => { }}
                />
            </Box>

            {/* Right side - Card info */}
            <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 0,
                justifyContent: 'flex-end'
            }}>
                <>
                    <Typography variant="h5" sx={{
                        fontFamily: '"Playfair Display", serif',
                        fontWeight: 700,
                        color: theme.palette.background.dark,
                        marginBottom: '00px',
                        paddingBottom: '10px'
                    }}>
                        {t(card.card_name || '')}
                    </Typography>

                    {card.description?.interpretation && (
                        <Box>
                            <Typography variant="body2" sx={{
                                color: theme.palette.text.secondary,
                                lineHeight: 1.6,
                                fontSize: '0.9rem'
                            }}>
                                {t(card.description.interpretation || '')}
                            </Typography>
                        </Box>
                    )}
                </>
            </Box>
        </Box>
    );
};

export default DailyReadingCardDisplay;

